import { DEFAULT_COUNTRY_ID } from './constants';
import { PersonalInformationWidgetData } from './types';
import { INITIAL_SAVE_REQUEST_META } from '../utils';

const defaultPersonalInformationWidgetData: NonNullable<
  PersonalInformationWidgetData['initialData']
> = {
  pronoun: 'm',
  showPronoun: false,
  birthday: {
    canChange: false,
    dateOfBirth: '',
    display: 'none',
  },
  countryId: DEFAULT_COUNTRY_ID,
  countries: [],
  measurements: 'metric',
  canUpdateEmail: false,
};

export const defaultPersonalInformationWidgetState: PersonalInformationWidgetData = {
  initialData: defaultPersonalInformationWidgetData,
  currentData: defaultPersonalInformationWidgetData,
  isDirty: false,
  saveRequest: INITIAL_SAVE_REQUEST_META,
};
